import Stage2Player2Room from "../shared/Stage2Player2Room";

export default function Five_Players_Stage2_Player2(props) {
  return <Stage2Player2Room {...props} playerCount={5} hasLaptop={false} />;
}